import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section9 from "./Section9";
import Section10 from "./Section10";
import Section11 from "./Section11";


export default function Seo_ny() {
  return (
    <div className="Seo pt-[160px] sm:pt-0">
      <Helmet>
        <title> Best SEO Agency in New York | Mean3</title>
        <meta
        name="description"
        content=" Need a reliable SEO company in New York? Mean3 delivers expert SEO services to increase your website traffic, attract qualified leads, and drive sustainable business growth with proven strategies"
        />
      </Helmet>
      <Section1 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
      <Section11 />
      <Section9 />
      {/* <Section2 /> */}
      <Section10 />
      <Section3 />

    </div>
  );
}
